//@ts-check

// Repeating setTimeout that can be paused, resumed and restarted.
// Resuming or restarting always waits a full interval before the next tick.

/**
 * Timer used by SlideshowConductor.
 * It calls callback at set intervals and can be paused, resumed and restarted.
 */
export class Timer {
  /**
   * @param {() => void} callback
   * @param {{ interval: number, initialDelay?: number }} options
   */
  constructor(callback, { interval, initialDelay = interval }) {
    this.callback = callback;
    this.interval = interval;
    this.isRunning = true;
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    this.timeout = undefined;
    this._scheduleNextBeatFromNow(initialDelay);
  }

  _scheduleNextBeatFromNow(delay = this.interval) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (!this.isRunning) return;
      this.callback();
      this._scheduleNextBeatFromNow();
    }, delay);
  }

  pause() {
    this.isRunning = false;
    clearTimeout(this.timeout);
  }

  resume() {
    if (this.isRunning) return;
    this.isRunning = true;
    this._scheduleNextBeatFromNow();
  }

  // Wait a full interval from now (e.g. after a manual skip); no-op when paused.
  restart() {
    if (this.isRunning) this._scheduleNextBeatFromNow();
  }

  destroy() {
    this.pause();
  }
}
